import React, { Fragment } from 'react';
// import Navbar from '../components/Navbar/Navbar';
// import Footer from '../components/Footer/Footer';
// import Hero2 from '../components/Hero2/Hero2';
// import SocialProof from '../components/SocialProof/SocialProof';
// import Content from '../components/Content/Content';
// import Benefits from '../components/Benefits/Benefits';
// import OptionsTabs from '../components/OptionsTabs/OptionsTabs';
// import CTA from '../components/CTA/CTA';
// import Gallery from '../components/Gallery/Gallery';
// import Process from '../components/Process/Process';
// import FAQs from '../components/FAQs/FAQs';

type RentaCajasSecasProps = {}

const RentaCajasSecas:React.FC<RentaCajasSecasProps> = (props: RentaCajasSecasProps) => {
  return (
    <Fragment>
      {/* <Navbar fixedScrolled={true} contactRibbon={true} />
      <Hero2 />
      <SocialProof />
      <Benefits
        title="¿Por qué rentar tu caja seca con nosotros en Hidalgo?"
        description="Aquí hay algunas razones por las cuales nuestros clientes nos dan su confianza para la renta de cajas secas"
        slots={[
          {
            title: 'Entrega inmediata',
            content: 'Contamos con una flota activa de más de 50 cajas secas y plataformas disponibles para entrega inmediata, listas para integrarse a tu operación sin generar tiempos muertos.'
          },
          {
            title: 'Cajas secas en perfecto estado',
            content: 'Todos nuestros equipos reciben mantenimiento constante y revisiones periódicas para garantizar un funcionamiento seguro, eficiente y confiable durante toda tu operación.'
          },
          {
            title: 'Mantenimiento incluido',
            content: 'Esto te dará tranquilidad ya que no tendrás que gestionar el mantenimiento y tendrás la garantía que las cajas secas estén en condiciones óptimas.'
          },
          {
            title: 'Ubicación estratégica en Hidalgo',
            content: 'Nuestra ubicación en Hidalgo nos permite atender con rapidez a empresas y transportistas en todo el centro del país, reduciendo costos y tiempos de traslado del equipo.'
          },
          {
            title: 'Atención rápida y personalizada',
            content: 'Brindamos atención directa vía llamada o WhatsApp, con respuesta inmediata y asesoría personalizada para ayudarte a elegir el equipo más adecuado según tu tipo de carga.'
          },
        ]}
      />
      <OptionsTabs />
      <CTA 
        title="Servicio profesional de renta de cajas secas en Hidalgo" 
        description="Grupo GM ofrece renta de cajas secas en Hidalgo, con equipos en excelente estado y atención profesional. Brindamos soluciones confiables y rápidas para transporte y logística. Si buscas servicio seguro y eficiente, Grupo GM es tu mejor opción."
        buttonText="Cotizar ahora"
      />
      <Process />
      <Gallery />
      <Content />
      <FAQs />
      <Footer /> */}
    </Fragment>
  )
}

export default RentaCajasSecas;